import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import { localize } from 'helpers/translator'
import TeachMode from './teach_mode/teach_mode'

import styles from './teach_modes.scss'

import LiveParticipation from 'assets/components/teach_modes/live_participation.svg'
import FrontOfClassroom from 'assets/components/teach_modes/front_of_classroom.svg'
import LiveZoom from 'assets/components/teach_modes/live_zoom.svg'
import StudentPaced from 'assets/components/teach_modes/student_paced.svg'

const TeachModes = props => (
	<div styleName='container'>
		{props.canLaunchSession &&
			<TeachMode
				buttonAction={props.launchLiveLesson}
				buttonText={`${localize('lessons_list_npp_action_live_participation')}`}
				image={LiveParticipation}
				tooltip={localize('my_library_teach_modal_live_participation_tooltip')}
				linkText={localize('my_library_teach_modal_resume_active_session')}
				linkAction={props.onLiveActiveCodesSelected}
				shouldShowLink={props.hasActiveLiveCodes}
			/>
		}
		{props.canLaunchSessionWithZoom &&
			<TeachMode
				buttonAction={props.launchLiveLessonWithZoom}
				buttonText={`${localize('lessons_list_npp_action_live_zoom')}`}
				image={LiveZoom}
				tooltip={localize('my_library_teach_modal_live_zoom_tooltip')}
				linkText={localize('my_library_teach_modal_resume_active_session')}
				linkAction={props.onLiveWithZoomActiveCodesSelected}
				shouldShowLink={props.hasActiveLiveCodes}
			/>
		}
		{props.canLaunchHomework &&
			<TeachMode
				buttonAction={props.launchHomework}
				buttonText={`${localize('lessons_list_npp_action_student_paced')}`}
				image={StudentPaced}
				tooltip={localize('my_library_teach_modal_student_paced_tooltip')}
				linkText={localize('my_library_teach_modal_view_active_sessions')}
				linkAction={props.onHomeworkActiveCodesSelected}
				shouldShowLink={props.hasActiveHomeworkCodes}
			/>
		}
		{props.canLaunchFrontOfTheClassroom &&
			<TeachMode
				buttonAction={props.launchFrontOfTheClassroom}
				buttonText={`${localize('lessons_list_npp_action_launch_video_2')}`}
				image={FrontOfClassroom}
				tooltip={localize('my_library_teach_modal_front_of_class_tooltip')}
			/>
		}
	</div>
)

TeachModes.propTypes = {
	canLaunchFrontOfTheClassroom: PropTypes.bool,
	canLaunchSession: PropTypes.bool,
	canLaunchSessionWithZoom: PropTypes.bool,
	canLaunchHomework: PropTypes.bool,
	launchFrontOfTheClassroom: PropTypes.func,
	launchLiveLesson: PropTypes.func,
	launchHomework: PropTypes.func,
	launchLiveLessonWithZoom: PropTypes.func,
	hasActiveLiveCodes: PropTypes.bool,
	hasActiveHomeworkCodes: PropTypes.bool,
	onLiveActiveCodesSelected: PropTypes.func,
	onHomeworkActiveCodesSelected: PropTypes.func,
	onLiveWithZoomActiveCodesSelected: PropTypes.func,
}

TeachModes.defaultProps = {
	canLaunchFrontOfTheClassroom: false,
	canLaunchSession: false,
	canLaunchSessionWithZoom: false,
	canLaunchHomework: false,
	launchFrontOfTheClassroom: () => {},
	launchLiveLesson: () => {},
	launchHomework: () => {},
	launchLiveLessonWithZoom: () => {},
	hasActiveLiveCodes: false,
	hasActiveHomeworkCodes: false,
	onLiveActiveCodesSelected: () => {},
	onHomeworkActiveCodesSelected: () => {},
	onLiveWithZoomActiveCodesSelected: () => {},
}

export default CSSModules(TeachModes, styles, {allowMultiple: true})


